import axios from 'axios'
import firebase from 'firebase/app'

const API_HOST = 'https://oncrypto.herokuapp.com/'
// const API_HOST = 'http://192.168.1.33:5000/'

export default {
    state: {
        favorites: [],
        tickers: [],
    },
    mutations: {
        setMaketsFavs: (s, f) => s.favorites = f,
        setTickers: (s, t) => s.tickers = t,
    },

    getters: {
        getMarketsFavs: (s) =>  s.favorites,
        getTickers: (s) => s.tickers
    },
    actions: {
        async fetchMarketsFavs({ dispatch, commit }) {
            try {
                const uid = await dispatch('getUid');
                const favorites = (await firebase.database().ref(`/users/${uid}/markets-favorites`).once('value')).val() || {}
                const favs = Object.entries(favorites).map(([exchange, favs]) => ({
                    exchange,
                    favorites: Object.entries(favs).map(([id, fav]) => ({ id, ...fav }))
                }))
                commit('setMaketsFavs', favs)
                return favs;
            } catch (e) {
                commit('setError', e)
                throw e
            }
        },
        async addToMarketsFavs({ dispatch, commit }, { ticker, exchange }) {
            try {
                const uid = await dispatch('getUid')
                await firebase.database().ref(`/users/${uid}/markets-favorites/${exchange}`).push(ticker);
                await dispatch('fetchMarketsFavs');
            } catch (e) {
                commit('setError', e)
                throw e
            }

        },
        async deleteFromMarketsFavs({ commit, dispatch }, { id, exchange }) {
            try {
                const uid = await dispatch('getUid')
                await firebase.database().ref(`/users/${uid}/markets-favorites/${exchange}/`).child(id).remove();
                await dispatch('fetchMarketsFavs');
            } catch (e) {
                commit('setError', e)
                throw e
            }
        },
        async getMarketTickers({ dispatch, commit }, { exchange, pair }) {
            pair = pair === 'ALL' ? null : pair
            return await axios.get(API_HOST + 'markets', {
                params: {
                    exchange,
                    pair
                },
            })
                .then(response => {
                    return response.data.data
                }).catch(error => {
                    return error
                })
        },

    }
}